var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { TextField, CircularProgress } from "@mui/material";
import { forwardRef } from "react";
import { IconButton, Divider } from "@mui/material";
/**
 * Custom MUI TextField with an end adornment
 * @param props
 * @returns
 */
export const ActionTextField = forwardRef((props, ref) => {
    const { endIconButtonType, disabled, formId, loading, endIcon, inputComponent } = props, rest = __rest(props, ["endIconButtonType", "disabled", "formId", "loading", "endIcon", "inputComponent"]);
    return (_jsx(TextField, Object.assign({}, rest, { InputProps: {
            endAdornment: (_jsxs(_Fragment, { children: [_jsx(Divider, { flexItem: true, sx: { my: 0.5, mr: 1, borderColor: "rgba(0,0,0,.23)" }, orientation: "vertical" }), _jsx(IconButton, Object.assign({ form: formId, type: endIconButtonType, disabled: disabled, color: "primary" }, { children: loading ? _jsx(CircularProgress, { size: 25 }) : endIcon }))] })),
            inputComponent: inputComponent && inputComponent,
        } })));
});
